import { SERVICES_INDEX } from "@constant/common";
import { SERVICE } from "@constant/types";
import { showError, showSuccess, updatePdpItem, updatePdpItemStatus } from "@context/actions";
import { replaceAppointmentServices } from "@context/actions/appointment";
import Backdrop from "@material-ui/core/Backdrop";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import AppointmentServiceModal from "@module/appointmentServiceModal";
import { navigateTo } from '@util/routerService';
import { formattedDuration, isActiveAtBinaryIndex, processTaxList } from "@util/utils";
import { windowRef } from "@util/window";
import { useRouter } from 'next/router';
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from 'react-redux';

import {
  CloseIcon,
  CloseLargeIcon,
  CopyClipboardIcon,
  FacebookBrandIcon,
  IconFrame,
  ShareIcon,
  TimerIcon,
  WhatsappBrandIcon,
} from '@element/icons';
const shareIconList = [
    {
        name: 'Whatsapp',
        icon: <WhatsappBrandIcon />
    },
    {
        name: 'Facebook',
        icon: <FacebookBrandIcon />
    },
    {
        name: 'Copy Link',
        icon: <CopyClipboardIcon />
    },
    // {
    //     name: 'Telegram',
    //     icon: "/assets/Icons/social/telegram.png"
    // },
    // {
    //     name: 'Twitter',
    //     icon: "/assets/Icons/social/twitter.png"
    // },
    // {
    //     name: 'Instagram',
    //     icon: "/assets/Icons/social/instagram.png"
    // }, 
    // {
    //     name: 'Linkedin',
    //     icon: "/assets/Icons/social/linkedin.png"
    // },
]
function ServicePdpModal() {
    const router = useRouter();
    const dispatch = useDispatch();
    const cartItems = useSelector((state: any) => state.orderItems);
    const appointmentItems = useSelector((state: any) => state.appointmentServices);
    const item = useSelector((state: any) => state.pdpItem);
    const pdpItemStatus = useSelector((state: any) => state.pdpItemStatus);
    const [showLongDescription, setShowLongDescription] = useState(false);
    const store = useSelector((state: any) => state);
    const languageData: any = store.languageKeywords
    const activeLanguage: any = store.activeLanguage
    const shortDescription = (item?.languages && item.languages[activeLanguage?.languageId]?.description) ? item.languages[activeLanguage?.languageId]?.description : (item?.description ? item?.description?.substring(0, 90) : '');
    const alreadyShortDescription = item?.description <= item?.description?.substring(0, 110);
    const baseRouteUrl = useSelector((state: any) => state.store.baseRouteUrl);
    const [isAlreadyAdded, setIsAlreadyAdded] = useState(false);
    const { configData, keywords } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const [availableWidth, setAvailableWidth] = useState(400);
    const [selectedVariationService, setSelectedVariationService] = useState<any>('');
    const [selectedVariation, setSelectedVariation] = useState<any>('');
    const storeMetaData = useSelector((state: any) => state.store ? state.store.storeMetaData : null);
    const [descList, setDescList] = useState(item?.description ? item?.description?.split('||') : []);
    const [openShareModal, setOpenShareModal] = useState(false);
    const currentPage = useSelector((state: any) => state.currentPage);
    const [showAppointmentServiceModal, setshowAppointmentServiceModal] = useState(false);
    const [cookie, setCookie] = useCookies()
    const [userData, setUserData] = useState(cookie['user']);

    useEffect(() => {
        if (windowRef) {
            document.body.classList.add("o-h")
        }
        return () => {
            dispatch(updatePdpItem(null));
            setshowAppointmentServiceModal(false)
            document.body.classList.remove("o-h")
        }

    }, [windowRef]);

    useEffect(() => {
        if (item?.description?.includes('||')) {
            setDescList(item?.description?.split('||'))
        }
    }, [item])

    useEffect(() => {
        if (windowRef) {//set width for pdp modal depend on screen size
            setAvailableWidth(window?.screen?.availWidth > 480 ? 480 : window?.screen?.availWidth);
        }
    }, [item, windowRef]);

    useEffect(() => {
        setIsAlreadyAdded(false);
        if (Boolean(item) && appointmentItems.length && !selectedVariation) {//here selectedVariation check is for the first time page load
            const itemIndex: number = appointmentItems.findIndex((appointentItem) => (appointentItem.id == item?.id));
            if (itemIndex != -1) {
                let serviceCopy = { ...appointmentItems[itemIndex] }
                if (serviceCopy.variations?.length != 0) {
                    setSelectedVariation(getSelectedVariationObj(serviceCopy));
                    setSelectedVariationService({ ...serviceCopy });
                } else {
                    setIsAlreadyAdded(true);
                }
            }
        }
    }, [appointmentItems, item]);

    useEffect(() => {
        // check selected service variations already added to cart for respective variation
        if (selectedVariation && appointmentItems.length) {
            let isAlreadyAdded = false;
            appointmentItems.map((appointentItem) => {
                if (appointentItem.id == item?.id) {//get list of cart items having same service data as current pdp item
                    if (appointentItem.variations?.length != 0) {
                        const cartVariations = getSelectedVariationObj(appointentItem);
                        if (JSON.stringify(cartVariations) === JSON.stringify(selectedVariation)) {//check for item of same service and selected variations
                            isAlreadyAdded = true;
                        }
                    } else {
                        isAlreadyAdded = true;
                    }
                }
            })
            setIsAlreadyAdded(isAlreadyAdded);
        }
    }, [selectedVariation, appointmentItems]);

    const getSelectedVariationObj = (service) => {
        const selectedVariations = { variant: '', subVariant: '', subSubVariant: '', }
        if (service.variations?.length != 0) {
            let vObj = service.variations[0];
            selectedVariations.variant = vObj.name;//weekdays or weekend
            if (vObj.variations?.length != 0) {
                vObj = vObj.variations[0]
                selectedVariations.subVariant = vObj.name;//male or female
            }
            if (vObj.variations?.length != 0) {
                vObj = vObj.variations[0]
                selectedVariations.subSubVariant = vObj.name;//adult or kids
            }
        }
        return { ...selectedVariations };
    }

    const closePdpMOdal = (from = '') => {
        if (!showAppointmentServiceModal) {
            if (from != 'Click-Away') {
                document.body.classList.remove("o-h")
                // document.body.style.overflow = 'unset';
                // router.push(baseRouteUrl + 'home');
                dispatch(updatePdpItem(null));
                if (pdpItemStatus) {
                    navigateTo('home');
                    dispatch(updatePdpItemStatus(null));
                }
            }
        }
    }

    const onClickAddToBooking = () => {
        if (configData.storeConfig?.appointmentConfig?.showBookedSlot) {
            setshowAppointmentServiceModal(true)
        } else {
            addToAppointment();
        }
    }

    const addToAppointment = () => {
        if (item?.variations?.length !== 0 && !selectedVariationService) {
            dispatch(showError(`${languageData['Select service variation'] ? languageData['Select service variation'] : 'Select service variation'}`, 3000));
            return;
        }
        const appointmentItemsCopy = appointmentItems ? [...appointmentItems] : [];
        const serviceCopy = { ...item };
        if (item?.variations?.length !== 0) {
            appointmentItemsCopy.push(selectedVariationService);
        } else {
            serviceCopy.txchrgs = [];
            let price: any = parseFloat(serviceCopy.price);
            let salePrice: any = parseFloat(serviceCopy.salePrice);
            let memberPrice: any = parseFloat(serviceCopy.memberPrice);
            serviceCopy.price = price;
            serviceCopy.salePrice = salePrice;
            serviceCopy.memberPrice = memberPrice;
            serviceCopy.txchrgs = calculateTaxes(userData?.membership?.length == 1 && userData.membership[0].typeId == 4 ? (memberPrice) : (salePrice || price), serviceCopy.taxCharges);
            appointmentItemsCopy.push(serviceCopy);
        }
        dispatch(replaceAppointmentServices(appointmentItemsCopy));
        dispatch(showSuccess(`${languageData['Service Added'] ? languageData['Service Added'] : 'Service Added'}`, 2000));
        if (router?.query?.pagepath?.includes('appointment')) {//incase of appointment after adding item to appointment close modal
            closePdpMOdal();
        } else {
            navigateTo('appointment')
            dispatch(updatePdpItemStatus(null));
            document.body.classList.remove("o-h")
            dispatch(updatePdpItem(null));
        }
    }
    const removeFromAppointment = () => {
        const appointmentItemsCopy = appointmentItems ? [...appointmentItems] : [];
        let cartItemIndex = null;
        appointmentItems.map((appointentItem, i) => {
            if ((appointentItem.id == item?.id)) {//get list of cart items having same service data as current pdp item
                if (appointentItem.variations?.length != 0) {
                    const cartVariations = getSelectedVariationObj(appointentItem);
                    if (JSON.stringify(cartVariations) === JSON.stringify(selectedVariation)) {//check for item of same service and selected variations
                        cartItemIndex = i;
                    }
                } else {
                    cartItemIndex = i;
                }
            }
        })
        appointmentItemsCopy.splice(cartItemIndex, 1);
        dispatch(replaceAppointmentServices(appointmentItemsCopy));
        dispatch(showSuccess(`${languageData['Service Removed'] ? languageData['Service Removed'] : 'Service Removed'}`, 2000));
        setIsAlreadyAdded(false);
        if (router?.query?.pagepath?.includes('appointment')) {//incase of appointment after adding item to appointment close modal
            closePdpMOdal();
        }
    }

    const calculateTaxes = (taxebalePrice: any, taxCharges: any) => {
        const hasTaxCharges = Boolean(taxCharges?.length);
        const taxesToProcess = hasTaxCharges ? taxCharges : configData.txchConfig || [];
        const taxList = taxesToProcess.filter(taxData =>
            taxData.active && (hasTaxCharges || (isActiveAtBinaryIndex(taxData.applyOn, SERVICES_INDEX) && !taxData.charge)));

        return processTaxList(taxList, taxebalePrice)

    };

    const onSelectVariation = (variantIndex: any, subVariantIndex: any, subSubVariantIndex: any, clickedVariant: any) => {
        if (clickedVariant.price) {
            const serviceCopy = { ...item };
            serviceCopy.txchrgs = [];
            let price: any = parseFloat(serviceCopy.price);
            let salePrice: any = parseFloat(serviceCopy.salePrice);
            let vObj = serviceCopy.variations[variantIndex];
            if (variantIndex != null) {
                serviceCopy.variations = [{
                    "id": vObj.id,
                    "name": vObj.name,
                    "price": vObj.price,
                    "salePrice": vObj.salePrice,
                    "variations": []
                }]
                price = parseFloat(vObj.price);
                salePrice = parseFloat(vObj.salePrice);
                if (subVariantIndex != null) {
                    vObj = vObj.variations[subVariantIndex]
                    serviceCopy.variations[0].variations = [{
                        "id": vObj.id,
                        "name": vObj.name,
                        "price": vObj.price,
                        "salePrice": vObj.salePrice,
                        "variations": []
                    }]
                    price = parseFloat(vObj.price);
                    salePrice = parseFloat(vObj.salePrice);
                }
                if (subSubVariantIndex != null) {
                    vObj = vObj.variations[subSubVariantIndex]
                    serviceCopy.variations[0].variations[0].variations = [{
                        "id": vObj.id,
                        "name": vObj.name,
                        "price": vObj.price,
                        "salePrice": vObj.salePrice,
                        "variations": []
                    }]
                    price = parseFloat(vObj.price);
                    salePrice = parseFloat(vObj.salePrice);
                }
            }
            serviceCopy.price = price;
            serviceCopy.salePrice = salePrice;
            serviceCopy.txchrgs = calculateTaxes(salePrice || price, serviceCopy.taxCharges);
            setSelectedVariation(getSelectedVariationObj(serviceCopy));
            setSelectedVariationService({ ...serviceCopy });
        }
    }
    // const onSharePage = async () => {
    //     if (window.navigator.share) {
    //         try {
    //             const catUrl = item.categoryName.toLowerCase().split(" ").join("-") + '-prp/';
    //             const itemUrl = catUrl + item.name.toLowerCase().split(" ").join("-") + '-pdp';

    //             await window.navigator.share({ title: `${item.name}`, url: `${storeMetaData.sUrl}/${itemUrl}` });
    //             console.log("Data was shared successfully");
    //         } catch (err) {
    //             // setOpenShareModal(true)
    //             console.error("Share failed:", err.message);
    //         }
    //     } else setOpenShareModal(true)
    // }

    const onClickSocialIcon = (linkData) => {
        const itemUrl = window.location.href + '/' + item.name.toLowerCase().split(" ").join("-") + '-pdp';
        switch (linkData.name) {
            case 'Facebook':
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${itemUrl}`, '_blank');
                break;
            case 'Twitter':
                window.open(`https://twitter.com/intent/tweet?text=${item.pTitle || item.name}&url=${itemUrl}`, '_blank');
                break;
            case 'Whatsapp':
                window.open(`https://api.whatsapp.com/send?text=${item.pTitle || item.name} ${itemUrl}`, '_blank');
                break;
            case 'Instagram':
                window.open(`https://www.instagram.com/?url=${itemUrl}`, '_blank');
                break;
            case 'Linkedin':
                window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${itemUrl}`, '_blank');
                break;
            case 'Telegram':
                window.open(`https://telegram.me/share/msg?url=${item.pTitle || item.name}&url=${itemUrl}`, '_blank');
                break;
            case 'Copy Link':
                window?.navigator?.clipboard?.writeText(decodeURIComponent(itemUrl));
                dispatch(showSuccess(`${languageData['Copied successfully'] ? languageData['Copied successfully'] : 'Copied successfully'}`));
                setOpenShareModal(false);
                break;
            default:
                break;
        }
    }

    return (
        <>
            {(item && item.type == keywords[SERVICE]) ?
                <div className="service-pdp-modal-wrap" style={{ width: `${availableWidth}px` }}>
                    <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                        <div className="pdp-cover">
                            <ClickAwayListener onClickAway={() => closePdpMOdal(currentPage == 'appointment' ? 'Click-Away' : '')}>
                                <div>
                                    <div className="modal-close" onClick={() => closePdpMOdal()}>
                                        <IconFrame><CloseIcon /></IconFrame>
                                    </div >
                                    {/* {windowRef() && window?.location?.protocol == 'https:' && <div className="modal-close modal-share" onClick={() => onSharePage()}>
                                        <IconFrame><ShareIcon /></IconFrame>
                                    </div>} */}
                                    {/* {item?.iTag && <div className="ribbon "><span>{item?.iTag}</span></div>} */}

                                    <Paper elevation={4} className="outer"
                                    // style={{ height: `${(appointmentItems && appointmentItems.length != 0) ? 'calc(100vh - 135px)' : 'calc(100vh - 100px)'}` }}
                                    >
                                        {/* <div className="prodpdpbanner">
                                            <ImageSlider itemsList={item?.imagePaths} config={{ redirection: false }} no_image={PDP_NO_IMAGE} />
                                        </div> */}
                                        <div className="service-pdp-details clearfix">
                                            <div className="serv-pdp-details-wrap clearfix">

                                                {item?.variations && item?.variations?.length !== 0 && <div className="serv-pdp-servtype">
                                                    <div className="serv-pdp-servtypename">{item.languages && item.languages[activeLanguage?.languageId]?.name ? item.languages[activeLanguage?.languageId]?.name : item?.name}</div>
                                                </div>}

                                                {item?.variations && item?.variations?.length !== 0 ?
                                                    <>
                                                        <div className="variations-wrap clearfix">
                                                            {item?.variations?.map((variant: any, variantIndex: any) => {    //weekdays/weekends
                                                                if (('showOnUi' in variant) ? variant.showOnUi : true) {
                                                                    return <React.Fragment key={variantIndex}>
                                                                        <div className={`variation-name variant1 clearfix ${(!variant.variations || variant.variations.length == 0) && 'variation-wrap'} ${(selectedVariation?.variant == variant.name) && 'active'}`}
                                                                            onClick={() => onSelectVariation(variantIndex, null, null, variant)}
                                                                        >
                                                                            <div className='service-name'>{variant.name} </div>
                                                                            {variant.price > 0 && <div className="service-price">{configData.currencySymbol}{variant.salePrice || variant.price}</div>}
                                                                        </div>
                                                                        {variant.variations && variant.variations?.length !== 0 && variant.variations?.map((subVariant: any, subVariantIndex: any) => {    //male/female
                                                                            if (('showOnUi' in subVariant) ? subVariant.showOnUi : true) {
                                                                                return <React.Fragment key={subVariantIndex}>
                                                                                    {(subVariant.variations && subVariant.variations?.length !== 0) ?
                                                                                        <>
                                                                                            {subVariant?.variations?.map((subSubVariant: any, subSubVariantIndex: any) => {    //adult/kid
                                                                                                if (('showOnUi' in subSubVariant) ? subSubVariant.showOnUi : true) {
                                                                                                    return <div key={subSubVariantIndex}
                                                                                                        className={`variation-wrap variant3 clearfix ${(selectedVariation?.variant == variant.name && selectedVariation?.subVariant == subVariant.name && selectedVariation?.subSubVariant == subSubVariant.name) && 'active'}`}
                                                                                                        onClick={() => onSelectVariation(variantIndex, subVariantIndex, subSubVariantIndex, subSubVariant)}>
                                                                                                        {subSubVariant.name && <div className="variation-name">{subSubVariant.name}</div>}
                                                                                                        {subSubVariant.price && <div className="variation-price">{configData.currencySymbol}{subSubVariant.salePrice || subSubVariant.price}</div>}
                                                                                                    </div>
                                                                                                }
                                                                                            })}
                                                                                        </> :
                                                                                        <>
                                                                                            {subVariant.price <= 0 ?
                                                                                                <div className="variation-name variant2">{subVariant.name}</div> :
                                                                                                <div className={`variation-wrap clearfix ${(selectedVariation?.variant == variant.name && selectedVariation?.subVariant == subVariant.name) && 'active'}`}
                                                                                                    onClick={() => onSelectVariation(variantIndex, subVariantIndex, null, subVariant)}>
                                                                                                    {subVariant.name && <div className="variation-name">{subVariant.name}</div>}
                                                                                                    <div className="variation-price">{configData.currencySymbol}{subVariant.salePrice || subVariant.price}</div>
                                                                                                </div>}
                                                                                        </>
                                                                                    }
                                                                                </React.Fragment>
                                                                            }
                                                                        })}
                                                                    </React.Fragment>
                                                                }
                                                            })}
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className="serv-pdp-servtype clearfix">
                                                            <div className="serv-pdp-servtypename">{item.languages && item.languages[activeLanguage?.languageId]?.name ? item.languages[activeLanguage?.languageId]?.name : item?.name}</div>
                                                            <div className="serv-pdp-servofferforpr">{configData.currencySymbol}
                                                                {userData?.membership?.length == 1 && userData.membership[0].typeId == 4 ? (item?.memberPrice) : (item?.salePrice || item?.price)}
                                                            </div>
                                                        </div>
                                                        {item?.iTag && <div className="itag"><span>( {item.languages && item.languages[activeLanguage?.languageId]?.iTag ? item.languages[activeLanguage?.languageId]?.iTag : item.iTag} )</span></div>}
                                                    </>}
                                                <div className="serv-pdp-servtype clearfix">
                                                    {/* <div className="serv-pdp-servname">{item?.categoryName}</div> */}
                                                    {item?.duration !== 0 && <div className="serv-pdp-servtypetime d-f-s">
                                                        <IconFrame><TimerIcon /></IconFrame>
                                                        {formattedDuration(item)}
                                                    </div>}
                                                </div>
                                                {item?.description && item?.description?.includes('||') ? <>
                                                    <div>{languageData["Description"] ? languageData["Description"] : "Description"}</div>
                                                    {descList.map((desc: any, i: number) => {
                                                        return <div className="serv-pdp-servtypedesc serv-pdp-servtypedesc-list" key={Math.random()}><span>&#8226;</span>{desc} </div>
                                                    })}
                                                </> : <>
                                                    {item?.description && <>
                                                        {alreadyShortDescription && <>
                                                            <div className="serv-pdp-servtypedesc"> {item?.languages && item.languages[activeLanguage?.languageId]?.description ? item.languages[activeLanguage?.languageId]?.description : item?.description}</div>
                                                        </>}
                                                        {!alreadyShortDescription && <>
                                                            {showLongDescription && <div className="serv-pdp-servtypedesc" onClick={() => setShowLongDescription(false)}>
                                                                {item?.languages && item.languages[activeLanguage?.languageId]?.description ? item.languages[activeLanguage?.languageId]?.description : item?.description}
                                                                <span>{languageData["Read Less"] ? languageData["Read Less"] : "Read Less"}</span>
                                                            </div>}
                                                            {!showLongDescription && <div className="serv-pdp-servtypedesc" onClick={() => setShowLongDescription(true)}>
                                                                {shortDescription}...
                                                                <span >{languageData["Read More"] ? languageData["Read More"] : "Read More"}</span>
                                                            </div>}
                                                        </>}
                                                    </>}
                                                </>}

                                                {configData.storeConfig?.appointmentConfig?.active ? <div className="btn-wrap">
                                                    {isAlreadyAdded ? <div className="btn added" onClick={removeFromAppointment}>{languageData["Remove From Appointment"] ? languageData["Remove From Appointment"] : "Remove From Appointment"}</div>
                                                        : <div className="btn" onClick={onClickAddToBooking}>{languageData["Book Appointment"] ? languageData["Book Appointment"] : "Book Appointment"}</div>}
                                                </div> :
                                                    <div className="note">Call <a href={`tel:+${storeMetaData.countryCode} ${storeMetaData.phone1}`}> +{storeMetaData.countryCode} {storeMetaData.phone1}</a> for book appointment</div>
                                                }
                                            </div>
                                        </div>
                                    </Paper>
                                    <Backdrop
                                        className="backdrop-modal-wrapper"
                                        open={openShareModal ? true : false}
                                        onClick={() => setOpenShareModal(false)}
                                    >
                                        <div className="backdrop-modal-content social-sharing-modal"
                                            style={{ height: `${openShareModal ? `315px` : '0'}` }}
                                        >
                                            <div className="heading" >{languageData["Share"] ? languageData["Share"] : "Share"} </div>
                                            <div className="modal-close" onClick={() => setOpenShareModal(false)}>
                                                <IconFrame><CloseLargeIcon /></IconFrame>
                                            </div>
                                            <div className='pricing-details-wrap'>
                                                <div className="preview-wrap" onClick={() => onClickSocialIcon({ name: 'Copy Link' })}>
                                                    {!!(item?.pImage || (item?.imagePaths && item?.imagePaths?.length != 0 ? item?.imagePaths[0].imagePath : '')) && <div className="img-wrap">
                                                        <img src={item?.pImage || (item?.imagePaths && item?.imagePaths?.length != 0 ? item?.imagePaths[0].imagePath : '')} alt={item.name} />
                                                    </div>}
                                                    <div className="title-wrap">
                                                        <div className="title">{item?.pTitle || item?.name}</div>
                                                        <div className="desc">{item?.pDescription || item?.description}</div>
                                                    </div>
                                                </div>
                                                <div className="icons-list">
                                                    {shareIconList.map((shareData: any, index: number) => {
                                                        return <div className="icon-wrap" key={index} onClick={() => onClickSocialIcon(shareData)}>
                                                            <div className="icon">{shareData.icon}</div>
                                                            <div className="name">{shareData.name}</div>
                                                        </div>
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </Backdrop>
                                </div>
                            </ClickAwayListener>
                        </div>
                    </Slide>
                    {showAppointmentServiceModal && <AppointmentServiceModal item={{ ...item, date: appointmentItems[0]?.date }} onClose={() => setshowAppointmentServiceModal(false)} />}
                </div > : null
            }
        </>
    );
}

export default ServicePdpModal;
